import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import * as _ from 'lodash';
import Divider from '@material-ui/core/Divider';
import {useTranslation} from "react-i18next";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 200,
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        height: 'calc(100vh - 50px)',
        'border-right': '1px solid lightgrey'
    },
    listSection: {
        backgroundColor: 'inherit',
    },
    ul: {
        backgroundColor: 'inherit',
        padding: 0,
    },
}));

interface ListItemProps {
    key: string;
    label?: string;
    icon?: any;
}

export interface OptionalMenuItemProps {
    header?: string;
    items: ListItemProps[];
}

interface OptionalMenuValueProps {
    [key: string]: OptionalMenuItemProps
}
export interface OptionalMenuProps {
    value: OptionalMenuValueProps,
    onChange(key: string): void;
}

const OptionalMenu: React.FC<OptionalMenuProps> = (props) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const [selectedItem, setSelectedItem] = useState({key: '', index: 0})
    const handleListItemClick = (event: any, key: string, index: number, itemKey: string) => {
        setSelectedItem({key, index});
        props.onChange(itemKey);
    }
    useEffect(() => {
        const location = window.location.pathname;
        if (location.includes('/settings/device/')) {
            const devicePath = location.replace('/settings/device/', '');
            Object.keys(props.value).map((key) => {
                const menuItem: OptionalMenuItemProps = _.get(props.value, `${key}`);
                const k = menuItem.items.findIndex((mi) => devicePath === mi.key);
                if (k !== -1) {
                    setSelectedItem({
                        key: key,
                        index: k
                    });
                    props.onChange(menuItem.items[k].key);
                }
            })
        } else if (location.includes('/settings/alarms/')) {
            const alarmPath = location.replace('/settings/alarms/', '');
            Object.keys(props.value).map((key) => {
                const menuItem: OptionalMenuItemProps = _.get(props.value, `${key}`);
                const k = menuItem.items.findIndex((mi) => alarmPath === mi.key);
                if (k !== -1) {
                    setSelectedItem({
                        key: key,
                        index: k
                    });
                    props.onChange(menuItem.items[k].key);
                }
            })
        }
    }, [window.location.pathname])
    const renderPartOfMenu = (key: string) => {
        const menuItem: OptionalMenuItemProps = _.get(props.value, `${key}`);
        
        const isToTranslate = key === 'options' || key === 'manualSettings';
        if (menuItem) {
            
            return (
                <ul className={classes.ul}>
                    <ListSubheader>{t(menuItem.header || '')}</ListSubheader>
                    <Divider/>
                    {menuItem.items.map((item, index) => (
                        <ListItem
                            key={`item-${menuItem.header}-${index}`}
                            selected={selectedItem.key === key && selectedItem.index === index}
                            button
                            onClick={(event) => handleListItemClick(event, key, index, item.key)}>
                            {
                                isToTranslate && <ListItemText primary={t(item.key)} />
                            }
                            {
                                !isToTranslate && <ListItemText primary={item.label || item.key} />
                            }
                        </ListItem>
                    ))}
                </ul>
            )
        }
        return null;
    }

    return (
        <List className={classes.root} subheader={<li />}>
            {Object.keys(props.value).map((key) => (
                <li key={`section-${key}`} className={classes.listSection}>
                    {renderPartOfMenu(key)}
                </li>
            ))}
        </List>
    )
}

export default OptionalMenu;
